import React, { useEffect, useState } from "react";
import APIService from "../../../modules/apiService";
import Spinner from "../../../components/spinner";
import CreateInvoiceModal from "./createInvoiceModal";
import { useBillingContext } from "..";
import { formatDate, formatMoney, formatNumber } from "../../../utils/formatters";

const api = new APIService();

export default function Appointments({ filters }) {
  const { showErrorModal } = useBillingContext();
  const [isLoading, setIsLoading] = useState(true);
  const [appointments, setAppointments] = useState(null);
  const [selectedAppointments, setSelectedAppointments] = useState([]);
  const [showCreateInvoiceModal, setShowCreateInvoiceModal] = useState(false);

  const toggleAppointmentSelection = (appointment) => {
    setSelectedAppointments((prev) => {
      const updated = prev.includes(appointment) ? prev.filter((a) => a !== appointment) : [...prev, appointment];
      return updated.sort((a, b) => b.id - a.id);
    });
  };

  const toggleAllAppointments = () => {
    if (selectedAppointments.length === appointments.length) {
      setSelectedAppointments([]);
    } else {
      setSelectedAppointments([...appointments].sort((a, b) => b.id - a.id));
    }
  };

  const handleInvoiceSelected = () => {
    setShowCreateInvoiceModal(true);
  };

  const fetchAppointments = async () => {
    setIsLoading(true);
    setSelectedAppointments([]);

    try {
      const response = await api.getMyAppointments({
        ...filters,
        without_invoice: true,
      });

      setAppointments(response.data);
    } catch (err) {
      showErrorModal(`Error al obtener los turnos: ${err.message}`);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchAppointments();
  }, [filters]);

  return (
    <>
      {isLoading && <Spinner />}
      {appointments?.length === 0 && <div className="p-3 text-muted text-center">No se encontraron turnos pendientes de facturación</div>}
      {appointments?.length > 0 && (
        <>
          <table className="table table-hover m-0">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" onChange={toggleAllAppointments} checked={appointments.length > 0 && selectedAppointments.length === appointments.length} />
                </th>
                <th className="text-right">Id</th>
                <th className="text-right">Fecha</th>
                <th className="text-center">Tipo</th>
                <th>Paciente</th>
                <th className="text-right">Documento</th>
                <th className="text-right">Importe</th>
              </tr>
            </thead>
            <tbody>
              {appointments.map((appointment, index) => (
                <tr key={index} onClick={() => toggleAppointmentSelection(appointment)} style={{ cursor: "pointer" }}>
                  <td>
                    <input type="checkbox" onClick={(e) => e.stopPropagation()} onChange={() => toggleAppointmentSelection(appointment)} checked={selectedAppointments.includes(appointment)} />
                  </td>
                  <td className="text-right">{formatNumber(appointment.id, 0)}</td>
                  <td className="text-right">{formatDate(appointment.start)}</td>
                  <td className="text-center">
                    <span className="badge badge-secondary">Turno</span>
                  </td>
                  <td>{appointment.patient ? appointment.patient.fullname : <small className="text-muted">Sin paciente</small>}</td>
                  <td className="text-right">{appointment.patient ? formatNumber(appointment.patient.identification, 0) : <small className="text-muted">Sin documento</small>}</td>
                  <td className="text-right">{formatMoney(appointment.consultation_price)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-3 p-3 text-right">
            <button className="btn btn-primary" onClick={handleInvoiceSelected} disabled={selectedAppointments.length === 0}>
              Facturar seleccionados
            </button>
          </div>
        </>
      )}
      {showCreateInvoiceModal && (
        <CreateInvoiceModal
          visible={showCreateInvoiceModal}
          onClose={() => {
            setShowCreateInvoiceModal(false);
          }}
          appointments={selectedAppointments}
          onInvoiced={(appointment) => {
            setAppointments((prev) => prev.filter((a) => a.id !== appointment.id));
            setSelectedAppointments((prev) => prev.filter((a) => a.id !== appointment.id));
          }}
          onSkip={(appointment) => {
            setSelectedAppointments((prev) => prev.filter((a) => a.id !== appointment.id));
          }}
          onComplete={() => {
            fetchAppointments();
          }}
        />
      )}
    </>
  );
}
